import React from 'react';
import { Grid, Typography } from '@mui/material';
import { ScrollOnMount } from '@shared/components/ScrollOnMount';
import { useFormik } from 'formik';
import * as yup from 'yup';
import {
  getAssistBookingDetail,
  getBookingDetail,
  getFlightsBookingDetail,
} from '@shared/services/services';

import StyledTextField from '@shared/components/StyledTextField';
import { StyledButtonConfirmar } from '@shared/components/Buttons/styles';

import { GridMainContainer, sxStyle } from '../styles';

const validationSchema = yup.object({
  reservationCode: yup
    .string('Ingrese el código de reserva')
    .required('El código de reserva es requerido'),
});

const Search = ({
  searchType,
  setBookingDetails,
  setIsLoading,
  setBookingStatus,
  setBookingLabel,
  setHasEntity,
  setHasError,
}) => {
  const handleSearch = async (fetchFn, values, resetForm) => {
    try {
      setIsLoading(true);
      const result = await fetchFn(values.reservationCode);

      setBookingDetails(result);
      setBookingStatus(result?.booking_status?.id_status);
      setBookingLabel(result?.booking_status?.label);

      const hasEntity = result?.entity && Object.keys(result.entity).length > 0;
      setHasEntity(hasEntity);

      if (result?.error === 'Not exist') {
        resetForm({});
        setHasError(true);
      }
    } catch (e) {
      console.error('error', e);
      resetForm({});
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: { reservationCode: '' },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      const actions = {
        0: () => handleSearch(getFlightsBookingDetail, values, resetForm),
        1: () => handleSearch(getBookingDetail, values, resetForm),
        default: () => handleSearch(getAssistBookingDetail, values, resetForm),
      };

      const search = actions[searchType] || actions.default;

      search();
    },
  });

  return (
    <GridMainContainer searchType={searchType} data-testid="bookingDetail_view">
      <ScrollOnMount />
      <Grid container direction="column" alignItems="center" sx={sxStyle.root}>
        <Grid item sx={sxStyle.gridPadding}>
          <Typography
            align="center"
            sx={{
              fontWeight: 700,
              color: '#000000',
              fontSize: { xs: '20px', md: '30px' },
              lineHeight: 1,
              paddingBottom: { xs: '15px', md: '20px' },
            }}
          >
            ¡Muchas gracias por elegirnos!
          </Typography>

          <Typography
            align="center"
            sx={{
              color: '#000000',
              fontSize: { xs: '12px', md: '18px' },
              lineHeight: 1,
              paddingBottom: { xs: '10px', md: '20px' },
            }}
          >
            Ingresá el localizador de tu reserva
          </Typography>

          <form onSubmit={formik.handleSubmit}>
            <Grid
              container
              justifyContent="center"
              sx={{
                marginBottom: { xs: '10px', md: '20px' },
              }}
            >
              <StyledTextField name="reservationCode" formik={formik} />
            </Grid>

            <StyledButtonConfirmar
              variant="contained"
              id="continueButton"
              disabled={!formik.values.reservationCode}
              type="submit"
              align="center"
              buttonConfirmarSx={{
                width: { xs: '100%', sm: '30%' },
              }}
            >
              Continuar
            </StyledButtonConfirmar>
          </form>
        </Grid>
      </Grid>
    </GridMainContainer>
  );
};

export default Search;
